/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity, userSupportedTypes } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';


export default declareLinkedEntity({
    entity: "channelTypeConversionDefs",
    graphQL: "ChannelTypeConversionDef",
    name: "Type Conversions",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    parentRelation: "channelTypeConversionDefs",
    defaultTitle: (data) => {
        return data['name'];
    },
    isPublic: true,
    dynamoPrefix: 'def',
    storageType: 'schema',
    onModify: ['channelDef'],
    fields: (types) => { return {
        id: {
            name: "Channel Type Conversion ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            compositeKey: true,
        },
        channelDef: {
            name: "Application Definition",
            to: () => types['channelDefs'],
            type: "relation",
            defaultValue: (channelDef) => {
                return channelDef['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        channelDefVersion: {
            name: "Channel Definition Version",
            to: () => types['channelDefVersions'],
            type: "relation",
            defaultValue: (channelDef) => {
                return channelDef['channelDefVersion_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        type: {
            name: "Type",
            type: "enum",
            defaultValue: "",
            values: userSupportedTypes,
            required: true,
        },
        conversion: {
            name: "Conversion",
            description: "Conversion of the type when generating API request",
            type: "string",
            defaultValue: "${value}",
        },
        format: {
            name: "Format",
            description: "Format of the type when generating API request",
            type: "string",
            defaultValue: "",
            visibility: (data) => data['type'] === 'date' || data['type'] === 'dateTime' || data['type'] === 'time',
        },
        formatParse: {
            name: "Parse Format",
            description: "Format of the type when parsing API response",
            type: "string",
            defaultValue: "",
            visibility: (data) => data['type'] === 'date' || data['type'] === 'dateTime' || data['type'] === 'time',
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
    }; }
});
